export enum ICertificateDocumentType {
    ServiceCard,
    ProductCertificate
}